import { useEffect, useState } from 'react';

import { isUndefined } from 'lodash';
import { useAccountSelector } from 'src/hooks';
import { MFormSection, MTypography } from 'src/lib';
import { Color, Spacing } from 'src/styles';
import { getAccountHolderSubheader } from 'src/utils';

import { FinancialInformationEmploymentForm } from './FinancialInformationEmploymentForm';
import { FinancialInformationEmploymentView } from './FinancialInformationEmploymentView';

export const JointAccountHolderFinancialEmploymentSection = () => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  const isFinancialInformationEmoloymentAlreadySaved = () =>
    !isUndefined(account?.secondaryAccountHolder?.financialInformation?.employmentStatus);

  useEffect(() => {
    if (isFinancialInformationEmoloymentAlreadySaved()) {
      setIsEditable(true);
    }
  }, [account?.secondaryAccountHolder?.financialInformation]);

  return (
    <>
      <MTypography
        variant='h4'
        weight='normal'
        color={Color.Brand6}
        className={Spacing.my32}
        testId='employment-joint-account-holder'>
        {getAccountHolderSubheader({
          isPrimary: false,
          type: account?.type,
          authorizedSigner: 2,
        })}
      </MTypography>
      <MFormSection
        title='Employment Information'
        onEdit={onEdit}
        disabled={Boolean(account?.lastFailedLinkAttemptError)}
        isEditable={isEditable}
        isEditMode={isEditMode}
        testId={'joint-account-employment-information'}>
        {isFinancialInformationEmoloymentAlreadySaved() && !isEditMode ? (
          <FinancialInformationEmploymentView accountHolder={account?.secondaryAccountHolder} testId={'joint'} />
        ) : (
          <FinancialInformationEmploymentForm
            accountHolder={account?.secondaryAccountHolder}
            accountUuid={account?.id}
            onCancel={onCancel}
            testId={'joint'}
          />
        )}
      </MFormSection>
    </>
  );
};
